interface MergeConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (targetTag: string) => void
  tag1: string
  tag2: string
  count1: number
  count2: number
}

export function MergeConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  tag1,
  tag2,
  count1,
  count2,
}: MergeConfirmationModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4">Merge Emotional Tags</h3>
        <p className="text-gray-700 mb-4">
          Choose which tag to keep. All documents using the other tag will be
          updated to use the selected tag.
        </p>

        <div className="space-y-3 mb-6">
          <button
            onClick={() => onConfirm(tag1)}
            className="w-full p-3 text-left border-2 border-blue-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors"
          >
            <div className="font-medium">&quot;{tag1}&quot;</div>
            <div className="text-sm text-gray-600">{count1} documents</div>
          </button>

          <button
            onClick={() => onConfirm(tag2)}
            className="w-full p-3 text-left border-2 border-blue-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors"
          >
            <div className="font-medium">&quot;{tag2}&quot;</div>
            <div className="text-sm text-gray-600">{count2} documents</div>
          </button>
        </div>

        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
